import { ANSWER_LANGUAGES, type AnswerLangCode } from "../lib/languages";
import { useLang } from "../hooks/useLang";

type Props = {
  value: AnswerLangCode;
  onChange: (code: AnswerLangCode) => void;
};

// Tema toggle'inin yanindaki cevap-dili dropdown'i. Yalnizca available diller
// secilebilir; digerleri disabled + "not available" etiketiyle gosterilir.
export default function LanguageSelect({ value, onChange }: Props) {
  const { t } = useLang();
  return (
    <select
      className="lang-select"
      value={value}
      onChange={(e) => onChange(e.target.value as AnswerLangCode)}
      title={t("lang_select_title")}
      aria-label={t("lang_select_title")}
    >
      {ANSWER_LANGUAGES.map((l) => (
        <option key={l.code} value={l.code} disabled={!l.available}>
          {l.flag} {l.available ? l.label : `${l.label} — ${t("lang_not_available")}`}
        </option>
      ))}
    </select>
  );
}
